/**
 * Money is integer US cents everywhere. Floats are banned in this codebase:
 * 0.1 + 0.2 !== 0.3, and an order total that is a cent out is a real dispute
 * with a real customer standing at a real door.
 *
 * Riel is derived, never stored, because the rate is a business decision that
 * changes. Vannak's retail sheet prices at exactly 4,000 riel to the dollar.
 */
/** Riel per USD used for display. Vannak's sheet: $4.50 shows as 18,000៛. */
export const KHR_PER_USD = 4000;
/** Smallest riel note in circulation. Riel totals are shown to this step. */
export const RIEL_ROUNDING = 100;
export function cents(value) {
    if (!Number.isFinite(value))
        throw new RangeError(`cents: not finite: ${value}`);
    if (!Number.isInteger(value))
        throw new RangeError(`cents: not an integer: ${value}`);
    if (value < 0)
        throw new RangeError(`cents: negative: ${value}`);
    return value;
}
/** Parse a dollar figure from a price sheet, e.g. "4.50" or 4.5, into cents. */
export function centsFromUsd(usd) {
    const n = typeof usd === "string" ? Number(usd) : usd;
    if (!Number.isFinite(n))
        throw new RangeError(`centsFromUsd: not a number: ${usd}`);
    // scale then round: 4.5 * 100 is 450.00000000000006 on some inputs
    return cents(Math.round(n * 100));
}
export function addCents(...values) {
    return cents(values.reduce((a, b) => a + b, 0));
}
export function mulCents(value, qty) {
    if (!Number.isInteger(qty) || qty < 0)
        throw new RangeError(`mulCents: bad qty: ${qty}`);
    return cents(value * qty);
}
/** Round up to the nearest step, e.g. quantiseUp(170, 25) === 175. */
export function quantiseUp(value, step) {
    if (!Number.isInteger(step) || step <= 0)
        throw new RangeError(`quantiseUp: bad step: ${step}`);
    return cents(Math.ceil(value / step) * step);
}
export function formatUsd(value) {
    return `$${(value / 100).toFixed(2)}`;
}
export function toRiel(value) {
    const raw = (value / 100) * KHR_PER_USD;
    return (Math.round(raw / RIEL_ROUNDING) * RIEL_ROUNDING);
}
export function formatRiel(value) {
    return `៛${toRiel(value).toLocaleString("en-US")}`;
}
//# sourceMappingURL=money.js.map